import { createGlobalStyle } from 'styled-components';

import { getDefaultTheme, getDarkTheme } from './theme';

const GlobalStyle = createGlobalStyle<{ isNewThemeActive?: boolean }>`
:root {
  ${getDefaultTheme}
}

[data-theme='dark'], .dark {
  ${getDarkTheme}
}
`;

export default GlobalStyle;
